// phonics_data_lt21.js
// Letter Teams L21 - L21 Long Vowel Sounds oo
// 路由：/phonics/lt21

const MEDIA_BASE = '/media/phonics/lt21';
const V = 'v1';

export const letterDataLt21 = {
  id: 'lt21',
  letter: 'L21',
  title: 'L21 Long Vowel Sounds oo',
  mediaBase: MEDIA_BASE,

  part1Video: { src: `${MEDIA_BASE}/part1.mp4?${V}` },
  part3Video: { src: `${MEDIA_BASE}/part3.mp4?${V}` },
  reviewPic: { src: `${MEDIA_BASE}/review.png?${V}` },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "Meg rides her broom.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "She drops her hoop.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Look! It is a hoop!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Pink steps in the hoop.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Poof!", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Pink is a hook!", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "What a funny hoop!", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Let me try.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Poof!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Yellow is a boot!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "Red goes in the hoop.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
        { en: "Poof!", audioEn: `${MEDIA_BASE}/story2_8.mp3?${V}` },
        { en: "Red is a book!", audioEn: `${MEDIA_BASE}/story2_9.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Blue goes in the hoop.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Poof!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Blue is a big spoon!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Meg flies to the roof.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "She reads her spell book.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Give my hoop back!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "She taps her foot.", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
        { en: "Poof!", audioEn: `${MEDIA_BASE}/story3_8.mp3?${V}` },
        { en: "Now she has her hoop!", audioEn: `${MEDIA_BASE}/story3_9.mp3?${V}` },
      ],
    },
  ],
};
